export default {
  fetched: false,
  list: {},
  // shapes: {},
  stores: {},
  flyerGibs: {},
  flyerGibsChildIdsMap: {},
  current: null,
  // id of the requested flyer that does not exist or is expired
  notFoundFlyerId: null,
  currentFlyerStores: [],
  // nearbyFlyers: [],
  flyersPageContentHeight: null,
};
